import {
  Box,
  Checkbox,
  FormControl,
  Grid,
  MenuItem,
  Select,
  TextField,
  Typography,
  useMediaQuery,
} from "@mui/material";
import Button from "components/Button";
import InputField from "components/InputField";
import { AlertPopup } from "components/AlertPopup";
import Password from "components/Password";
import BootstrapTooltip from "components/ToolTips/BootstrapTooltip";
import { Dispatch, SetStateAction, useEffect, useId, useState } from "react";
import { useIntl } from "react-intl";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import I18nKey from "translations/I18nKey";
import { countries, isValidEmail } from "utils/utils";
import WrongInput from "assets/Icons/WrongInput.svg";
import { SignUpProps } from "./types";
import MobilePassword from "components/MobilePassword";
import MobileTextField from "components/MobileTextField";
import { AlertPopupMobile } from "components/AlertPopupMobile";
import classNames from "classnames";

import useLoginSignupStyles from "./styles";
import { TryFreeOption } from "./TryFreeOption";
interface SignUpInfoInterface {
  handleModalClose: () => void;
  getSignupInitData: (data: SignUpProps) => {};
  setSingUpErr: Dispatch<SetStateAction<string>>;
  setUserName: Dispatch<SetStateAction<string>>;
  signUpErrorAlert: (str: string) => void;
  singUpErr: string;
  signupLoading: boolean;
}

export const SignUpInfoMobile: React.FC<SignUpInfoInterface> = ({
  handleModalClose,
  getSignupInitData,
  setSingUpErr,
  signUpErrorAlert,
  setUserName,
  singUpErr,
  signupLoading,
}) => {
  const intl = useIntl();
  const [isSuccess, setIsSuccess] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [inputModal, setInputModal] = useState<string>("");
  const [emailInputModal, setEmailInputModal] = useState<string>("");
  const isMobile = useMediaQuery("(max-width: 768px)");
  const [phoneNumberInputModal, setPhoneNumberInputModal] =
    useState<string>("");
  const [usernameInputModal, setUsernameInputModal] = useState<string>("");
  const [passwordInputModal, setPasswordInputModal] = useState<string>("");
  const [confirmPasswordInputModal, setConfirmPasswordInputModal] =
    useState<string>("");
  const [termsAndService, setTermsAndService] = useState<boolean>(false);
  const [termsAndServiceErr, setTermsAndServiceErr] = useState<string>("");
  const passwordFieldID = useId();
  const [openPasswordMenu, setOpenPasswordMenu] = useState<boolean>(false);
  const [passwordFieldConditions, setPasswordFieldConditions] = useState<
    string[]
  >([]);
  const [countryCode, setCountryCode] = useState<string>("US");
  const [phone, setPhone] = useState<string>("");
  const classes = useLoginSignupStyles();

  useEffect(() => {
    // For Password validation
    const passwordValidation = [];
    if (passwordInputModal) {
      setOpenPasswordMenu(true);
      if (passwordInputModal.length < 8)
        passwordValidation.push(
          intl.formatMessage({
            id: I18nKey.PASSWORD_CHARACTERS,
          })
        );
      if (!passwordInputModal.match(/[a-z]/g))
        passwordValidation.push(
          intl.formatMessage({
            id: I18nKey.PASSWORD_SMALL_LETTER,
          })
        );
      if (!passwordInputModal.match(/[A-Z]/g))
        passwordValidation.push(
          intl.formatMessage({
            id: I18nKey.PASSWORD_CAPLETTER,
          })
        );
      if (!passwordInputModal.match(/[^0-9a-zA-z]/g))
        passwordValidation.push(
          intl.formatMessage({
            id: I18nKey.PASSWORD_SPECIAL_SYMBOL,
          })
        );
      if (!passwordInputModal.match(/[0-9]/g))
        passwordValidation.push(
          intl.formatMessage({
            id: I18nKey.PASSWORD_NUMBER,
          })
        );
      if (!passwordInputModal.match(/^(?!.*^[^0-9a-zA-Z])/g))
        passwordValidation.push(
          intl.formatMessage({
            id: I18nKey.PASSWORD_NO_SPECIAL_SYMBOL,
          })
        );
      setPasswordFieldConditions(passwordValidation);
    } else {
      passwordValidation.length = 0;
    }
    if (passwordValidation.length === 0) {
      setOpenPasswordMenu(false);
    }
  }, [passwordInputModal, emailInputModal]);

  const checkInputType = (inputValue: string) => {
    const containsAtSymbol = inputValue.includes("@");
    const containsDigits = /^\d+$/.test(inputValue);
    const containsCharacters = /[a-zA-Z]/.test(inputValue);
    if (containsDigits && !containsCharacters && !containsAtSymbol) {
      setPhoneNumberInputModal(inputValue);
      setEmailInputModal("");
      setInputModal("");
    } else {
      setEmailInputModal(inputValue);
      setPhoneNumberInputModal("");
      setInputModal("");
    }
  };

  const handleEmailChangeModal = (e: React.ChangeEvent<HTMLInputElement>) => {
    setEmailInputModal(e.target.value);
    if (singUpErr.length > 0) setSingUpErr("");
    checkInputType(e.target.value);
  };

  const handlePhoneNumberChangeModal = (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    setPhoneNumberInputModal(e.target.value);
    if (singUpErr.length > 0) setSingUpErr("");
    checkInputType(e.target.value);
  };

  const handleChangeModal = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInputModal(e.target.value);
    if (singUpErr.length > 0) setSingUpErr("");
    checkInputType(e.target.value);
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
    if (e.key === " ") {
      e.preventDefault();
    }
  };

  const handleChangeUsernameModal = (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    setUsernameInputModal(e.target.value);
    if (singUpErr.length > 0) setSingUpErr("");
  };

  const handleChangePasswordModal = (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    setPasswordInputModal(e.target.value);
    if (singUpErr.length > 0) setSingUpErr("");
  };

  const handleConfirmChangePasswordModal = (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    setConfirmPasswordInputModal(e.target.value);
    if (singUpErr.length > 0) setSingUpErr("");
  };

  const handleSignupClick = async () => {
    if (
      !usernameInputModal ||
      !passwordInputModal ||
      (!emailInputModal && !phoneNumberInputModal) ||
      !termsAndService ||
      !confirmPasswordInputModal
    ) {
      if (!usernameInputModal) {
        signUpErrorAlert(
          intl.formatMessage({
            id: I18nKey.NO_USERNAME,
          })
        );
      } else if (!passwordInputModal) {
        signUpErrorAlert(
          intl.formatMessage({
            id: I18nKey.ENTER_PASSWORD,
          })
        );
      } else if (!confirmPasswordInputModal && passwordInputModal) {
        signUpErrorAlert(
          intl.formatMessage({
            id: I18nKey.RE_ENTER_PASSWORD,
          })
        );
      } else if (!emailInputModal && !phoneNumberInputModal) {
        signUpErrorAlert(
          intl.formatMessage({
            id: I18nKey.MOBILE_EMAIL,
          })
        );
      } else if (!termsAndService) {
        signUpErrorAlert(
          intl.formatMessage({
            id: I18nKey.TERMS_AND_CONDITIONS,
          })
        );
      }
      if (!termsAndService) {
        setTermsAndServiceErr(
          intl.formatMessage({
            id: I18nKey.TERMS_AND_SERVICE_ERR,
          })
        );
      }
    } else {
      if (passwordInputModal != confirmPasswordInputModal) {
        setSingUpErr(
          intl.formatMessage({
            id: I18nKey.PASSWORD_MISMATCH,
          })
        );
      } else if (emailInputModal && !isValidEmail(emailInputModal)) {
        setSingUpErr(
          intl.formatMessage({
            id: I18nKey.INVALID_EMAIL,
          })
        );
      } else if (phoneNumberInputModal && !countryCode) {
        setSingUpErr(
          intl.formatMessage({
            id: I18nKey.COUNTRY_CODE,
          })
        );
      } else {
        getSignupData();
      }
    }
  };

  const getSignupData = async () => {
    const commonPayload = {
      password: passwordInputModal,
      confirm_password: confirmPasswordInputModal,
      username: usernameInputModal,
    };
    const signUpPayload = {
      ...commonPayload,
      ...(phoneNumberInputModal
        ? { phone_no: phone + phoneNumberInputModal }
        : { email_id: emailInputModal }),
    };
    getSignupInitData(signUpPayload);
  };

  useEffect(() => {
    if (countryCode) {
      countries.map((country) => {
        if (country.code === countryCode) setPhone(country.phone);
      });
    }
  }, [countryCode]);
  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Box className={classNames(classes.createAccountContainer)}>
            <Typography className={classNames(classes.createAccount)}>
              {intl.formatMessage({
                id: I18nKey.CREATE_ACCOUNT,
              })}
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={12} md={12}>
          <MobileTextField
            value={usernameInputModal}
            onChange={handleChangeUsernameModal}
            placeholder={intl.formatMessage({
              id: I18nKey.NAME,
            })}
            err={singUpErr}
            className={classes.userName}
            type="string"
            onKeyDown={(e: React.KeyboardEvent<HTMLDivElement>) =>
              handleKeyDown(e)
            }
          />
        </Grid>

        <Grid item xs={12} md={12}>
          <MobilePassword
            value={passwordInputModal}
            type="password"
            onChange={handleChangePasswordModal}
            InputProps={{
              style: {
                border: "1px solid rgba(25, 118, 210, 0.12)",
              },
            }}
            placeholder={intl.formatMessage({
              id: I18nKey.SIGNIN_PASSWORD,
            })}
            id={`passwordModal ${passwordFieldID}`}
            conditions={passwordFieldConditions}
            openMenu={openPasswordMenu}
            err={singUpErr}
            className={classNames(classes.password)}
          />
        </Grid>
        <Grid item xs={12} md={12}>
          <MobilePassword
            value={confirmPasswordInputModal}
            type="password"
            onChange={handleConfirmChangePasswordModal}
            InputProps={{
              style: {
                border: "1px solid rgba(25, 118, 210, 0.12)",
              },
            }}
            placeholder={intl.formatMessage({
              id: I18nKey.REENTER_PASSWORD,
            })}
            id={`confirmPasswordModal ${passwordFieldID}`}
            err={singUpErr}
            className={classNames(classes.confirmPassword)}
          />
        </Grid>
        <Grid item xs={12}>
          {phoneNumberInputModal && (
            <>
              <Box sx={{ display: "flex" }}>
                <FormControl sx={{ marginRight: "10px !important" }}>
                  <Select
                    value={countryCode}
                    onChange={(e) => {
                      setCountryCode(e.target.value);
                    }}
                    placeholder={intl.formatMessage({
                      id: I18nKey.CODE,
                    })}
                    name="country_code"
                    size="medium"
                    sx={{
                      width: "50px",
                      background: "#fff",
                    }}
                  >
                    {countries.map((item) => (
                      <MenuItem key={item.code} value={item.code}>
                        {item.code + "(" + item.phone + ")"}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <MobileTextField
                  placeholder="Mobile Number"
                  value={phoneNumberInputModal}
                  width="100%"
                  onChange={handlePhoneNumberChangeModal}
                  autoFocus
                  sx={{ backgroundColor: "white", borderRadius: "10px" }}
                  onKeyDown={(e: React.KeyboardEvent<HTMLDivElement>) =>
                    handleKeyDown(e)
                  }
                  err={singUpErr}
                />
              </Box>
            </>
          )}
          {emailInputModal && (
            <MobileTextField
              placeholder={intl.formatMessage({
                id: I18nKey.EMAIL,
              })}
              value={emailInputModal}
              onChange={handleEmailChangeModal}
              autoFocus
              onKeyDown={(e: React.KeyboardEvent<HTMLDivElement>) =>
                handleKeyDown(e)
              }
              err={singUpErr}
              className={classNames(classes.emailPlaceHolder)}
            />
          )}
          {!phoneNumberInputModal && !emailInputModal && (
            <MobileTextField
              placeholder="Mobile Number or Email"
              value={inputModal}
              onChange={handleChangeModal}
              autoFocus
              onKeyDown={(e: React.KeyboardEvent<HTMLDivElement>) =>
                handleKeyDown(e)
              }
              err={singUpErr}
              width="100%"
            />
          )}
        </Grid>
        <Grid item xs={12}>
          <Box className={classNames(classes.ternsServiceContainer)}>
            <Checkbox
              checked={termsAndService}
              className={classNames(classes.checkBox)}
              onChange={(e) =>
                termsAndService
                  ? setTermsAndService(false)
                  : (setTermsAndService(true), setTermsAndServiceErr(""))
              }
            />
            <Typography
              className={classNames(classes.rWoodDocsAPi)}
              onClick={() =>
                window.open(
                  "https://ridgewood-partners.com/docsapis/",
                  "_blank"
                )
              }
            >
              {intl.formatMessage({
                id: I18nKey.TERMS,
              })}
            </Typography>
            <Box className={classNames(classes.toolTip)}>
              {termsAndServiceErr.length > 0 && !isMobile ? (
                <BootstrapTooltip title={termsAndServiceErr}>
                  <Box className={classNames(classes.wrongInput)}>
                    <img src={WrongInput} />
                  </Box>
                </BootstrapTooltip>
              ) : null}
            </Box>
          </Box>
        </Grid>

        <Grid item xs={12}>
          <Box className={classNames(classes.cancelSignupBtnsHolder)}>
            <Button
              primary={false}
              text={intl.formatMessage({
                id: I18nKey.SIGNUP_CANCEL,
              })}
              loading={false}
              disable={signupLoading}
              onClick={handleModalClose}
              className={classNames(classes.cancelBtn)}
            />
            <Button
              primary={true}
              text={intl.formatMessage({
                id: I18nKey.SIGNUP_BUTTON,
              })}
              loading={signupLoading}
              onClick={handleSignupClick}
              className={classNames(classes.signUpBtnInfo)}
            />
          </Box>
        </Grid>
        <Grid item xs={12}>
          <TryFreeOption />
        </Grid>
      </Grid>

      {singUpErr && isMobile ? (
        <AlertPopupMobile
          loading={isLoading}
          isSuccess={isSuccess}
          alertMsg={singUpErr}
          className={classNames(classes.alertPopupMobilesignUpInfo, {
            mobile: isMobile,
          })}
        />
      ) : null}
    </>
  );
};
